import { formatShortDateWithTimeSeconds } from '@dhl/utils'
import { EasySearchHitDto } from '@dhl/mdp-api'
import { Box, Body1, CardAccordion, Grid, H5, Paper } from '@dhl-ui/components'
import { CalendarIcon } from '@dhl-ui/icons'
import { PppHitDisplay, ClipboardCopy, PppErrors } from '~/modules/ppp/components'
import { hitHasWarningOrError, maybeHitWarningOrErrorIcon } from '~/modules/ppp/helpers'

type Props = {
  hits: EasySearchHitDto[]
  onlyErrors: boolean
  pid: string
}

export const PppHits = ({ hits = [], onlyErrors, pid }: Props) => (
  <Paper>
    {hits.map((hit, index) => {
      const title = hit.source?.toUpperCase() || ''
      return !onlyErrors || hitHasWarningOrError(hit) ? (
        <CardAccordion
          title={title}
          summary={formatShortDateWithTimeSeconds(hit.timestamp)}
          key={`${hit.correlationId}-${index}`}
          data-testid={`hit-${hit.correlationId}-${index}-main`}
        >
          <CardAccordion.Content>
            <Grid container direction="row" justifyContent="space-between" sx={{ mr: 1 }} alignItems="center">
              <Grid>
                {/* TODO: The error/warning should be shown in the top of the hit card. Awaiting Accordion component from UX */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <H5>{hitHasWarningOrError(hit) && maybeHitWarningOrErrorIcon(hit)}</H5>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <Body1>
                    <CalendarIcon sx={{ fontSize: 14 }} />
                    {formatShortDateWithTimeSeconds(hit.timestamp)}
                  </Body1>
                </Box>
                <Body1>{hit.correlationId}</Body1>
              </Grid>
              <Grid>
                <ClipboardCopy payload={hit.payload || ''} size={18} />
              </Grid>
            </Grid>
          </CardAccordion.Content>
          <CardAccordion.Footer data-testid={`hit-${hit.correlationId}-${index}-payload`}>
            {hitHasWarningOrError(hit) && <PppErrors hit={hit} />}
            <PppHitDisplay hit={hit} highlight={pid} />
          </CardAccordion.Footer>
        </CardAccordion>
      ) : null
    })}
  </Paper>
)
